<template>
	<div class="ReCallsObjTable">
		<div>
			<!-- <h3 class="text-center" v-if="masObjects.length==0">Ничего не найдено</h3>				 -->
			<card>
				<el-table
					ref="CallsObjTable"
					:data="objData" 
					@row-click="GoToObj" 
					:highlight-current-row="true"
					@sort-change="onSortChange"					
					style="width:100%!important;">	

					<!-- <el-table-column
						width="100"
						label="ID"
						property="id"
					></el-table-column> -->
					<!-- <el-table-column
						width="100"
						label="ID ячейки"
						property="cellId"
					></el-table-column> -->

					<el-table-column
					width="350"
					sortable
					label="АДРЕС"
					prop="address">
						<template v-slot="scope">
							<router-link class="nav-item" tag="a" :to="'/data/ColdCall/id/'+scope.row.id">{{scope.row.region}}, {{scope.row.address}}</router-link>
						</template>
					</el-table-column>

					<el-table-column
					sortable
					width="160"
					label="КОМНАТНОСТЬ"
					prop="categoryName">
					</el-table-column>

					<el-table-column
					width="120"
					label="ПЛОЩАДЬ"
					>
						<template v-slot="scope">
							<div v-if="scope.row.area!=null && scope.row.area!=''">{{scope.row.area}} м²</div>
							<div v-if="scope.row.roomsSpace!=null && scope.row.roomsSpace!=''">{{scope.row.roomsSpace}} м²</div>
							<div v-if="scope.row.houseSpace!=null && scope.row.houseSpace!=''">{{scope.row.houseSpace}} м²</div>
							<div v-if="scope.row.houseSpace!=null && scope.row.lotArea!=''">{{scope.row.lotArea}} м²</div>
						</template>
					</el-table-column>

					<el-table-column
					width="100"
					label="ЭТАЖ"
					prop="floor"
					>
						<template v-slot="scope">
							{{scope.row.floor}} / {{scope.row.floors}}
						</template>
					</el-table-column>

					<el-table-column
					width="140"
					sortable
					:sort-method="sortPrice"
					label="ЦЕНА"
					prop="price"
					>
						<template v-slot="scope">
							<div>{{$GVO.number_format(scope.row.price,0,'.',' ')}} ₽</div>
						</template>
					</el-table-column>

					<el-table-column
					width="180"
					sortable
					label="КЛАССИФИКАЦИЯ"
					prop="result_name"
					>
						<template v-slot="scope">
							<div>{{scope.row.result_name}} </div>
							<div v-if="scope.row.result_descr && scope.row.result_descr!=''">({{scope.row.result_descr}})</div>
						</template>
					</el-table-column>
					<el-table-column
					width="190"
					sortable
					label="КЛАССИФИЦИРОВАЛ"
					prop="agent_name"
					>
					</el-table-column>
					<el-table-column
					width="160"
					sortable					
					label="Последняя классификация"
					prop="UpdateTime"
					>
						<template v-slot="scope">
							<div v-if="scope.row.UpdateTime !='undefined' && scope.row.UpdateTime !=''">{{$GVO.convertDateTimeFromMysql(scope.row.UpdateTime)}}</div>
						</template>
					</el-table-column>
					<!-- <el-table-column
					width="190"
					sortable
					label="lastUpdateDate"
					prop="lastUpdateDate"
					>
					<template slot-scope="scope">
							<div v-if="scope.row.lastUpdateDate !='undefined' && scope.row.lastUpdateDate !=''">{{$GVO.convertDateTimeFromMysql(scope.row.lastUpdateDate)}}</div>
						</template>
					</el-table-column> -->
					<el-table-column
					width="190"
					sortable
					label="Дата создания"
					prop="creationDate"
					>
					<template v-slot="scope">
							<div v-if="scope.row.creationDate !='undefined' && scope.row.creationDate !=''">{{$GVO.convertDateTimeFromMysql(scope.row.creationDate)}}</div>
						</template>
					</el-table-column>

				</el-table>
			</card>

		</div>
	</div>
</template>

<script>
	import { Table, TableColumn } from 'element-ui';

	export default {
		name: 'ReCallsObjTable',
		components: {
			[Table.name]: Table,
			[TableColumn.name]: TableColumn,

		},
		props: {
			objData: [Array,Object],
			findId: { //это свойсво удалять не надо, оно хорошее и моет быть использовано в опуиях для формпринтера или фильтрпринтера
				type: String,
				default: '',
			},
			value: {
				type: String,
				default: 'callTable', // flat||complex||complexmap
			}, 
		},
		data () {
			return {
				ver: 1,
				fullscreenLoading: false,
				objSort:{prop: 'creationDate', order: 'descending'}, //InsertTime //cellId //creationDate //lastUpdateDate //descending //ascending
				objGetParams:{}
			}
		},
		/*
		watch: {
			objData: function (val) {
				console.log(this.objSort);
			},
		},
		*/
		computed: {

		},
		methods: {
			sortPrice(a,b){
				return parseInt(a.price) - parseInt(b.price);
			},					
			OnTabChange(strTabId){
				this.$emit('input', strTabId);
				this.$emit('change', strTabId);
				//this.loading = true;
				//this.openFullScreen2();
				this.openFullScreen1();
			},
			openFullScreen1() {
				this.fullscreenLoading = true;
				setTimeout(() => {
				this.fullscreenLoading = false;
				}, 2000);
			},
			GoToObj(rowData){
				//location.href = `/data/ColdCall/id/${rowData.id}`; 
				this.$router.push({path: `/data/ColdCall/id/${rowData.id}`});
			},
			onSortChange(objSort){
				//console.log(objSort);
				this.$emit('sort', objSort);
				this.objSort.prop = this.$GVO.unlinkObject(objSort.prop);
				this.objSort.order = this.$GVO.unlinkObject(objSort.order);
			}
		},
		mounted(){
			this.objGetParams = this.$GVO.GetAllGet();
			if(typeof this.objGetParams.sortProp != 'undefined'){
				this.objSort.prop = this.$GVO.unlinkObject(this.objGetParams.sortProp);
				this.objSort.order = this.$GVO.unlinkObject(this.objGetParams.sortOrder);
				this.$refs.CallsObjTable.sort(this.objSort.prop,this.objSort.order);
			}
		}
	}
</script>
<style scoped>
.ReCallsObjTable >>> .nav-pills .nav-item .nav-link {padding: 0px 20px;}
.ReCallsObjTable >>> .tab-content {margin-top: 15px;}

.card-wrapper {width: 100%; }
.card-wrapper-center {
    justify-content: center;
    margin: 0 auto;
    display: flex;
	max-width: 3000px;
}
.ReCallsObjTable >>> .el-table tr:hover {cursor: pointer; background: rgb(1, 176, 224, 0.33);}
.ReCallsObjTable >>>  .el-table table {width: 100%!important;}
.ReCallsObjTable >>>  .el-table .cell {word-break: break-word;}

/*===media===============================*/
@media (max-width: 768px) {
	.flat .row {width: 100%; margin-left: 0px;}
}

</style>
